import { render, staticRenderFns } from "./VideoModule.vue?vue&type=template&id=18854ab2&scoped=true&"
import script from "./VideoModule.vue?vue&type=script&lang=js&"
export * from "./VideoModule.vue?vue&type=script&lang=js&"
import style0 from "./VideoModule.vue?vue&type=style&index=0&id=18854ab2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18854ab2",
  null
  
)

export default component.exports